const PersonalInfo = {
    img: "Waiting For Image to be Imported", //TODO - Import img and set it here
    firstName: "Kashif",
    lastName: "Kamran",
    contactInfo: {
        phoneNos: [
            "+92 325 2265408",
            "+92 313 0160822"
        ],
        emails: [
            "kashifkamran.aalvi@gmail.com",
            "kashif.kamran.eliv@gmail.com"
        ]
    },
    address: {
        permenent: {
            otherInfo: "p/o box khass, thalvadi, tehseel Rahimyar Khan, district Rahimyar Khan",
            country: "Pakistan",
            city: "Rahimyar Khan",
        }
    }
}
export default PersonalInfo;